import { makeApi } from "@zodios/core";
import { z } from "zod";

import { reinterventionReasonDtoSchema } from "@/types/backoffice/dto/reintervention/reintervention-reason-dto.ts";
import { reinterventionSiteCommentDtoSchema } from "@/types/backoffice/dto/reintervention/reintervention-site-comment-dto.ts";

export const updateSiteReinterventionCommentBody = z.object({
  comment: z.string(),
  links: z.array(
    z.object({
      csLinkId: z.number(),
      comment: z.string(),
    }),
  ),
  refReinterventionGlobalReasonId: z.number(),
});

export const backofficeReinterventionApi = makeApi([
  {
    method: "get",
    path: "/reasons",
    response: z.array(reinterventionReasonDtoSchema),
    alias: "findAllReinterventionReasons",
  },
  {
    method: "get",
    path: "/comment/site/:id",
    response: reinterventionSiteCommentDtoSchema,
    alias: "findSiteReinterventionComment",
  },
  {
    method: "get",
    path: "/reasons/:id",
    response: reinterventionReasonDtoSchema,
    alias: "findReinterventionReasonById",
  },
  {
    method: "put",
    path: "/comment/site/:id",
    response: reinterventionSiteCommentDtoSchema,
    alias: "updateSiteReinterventionComment",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: updateSiteReinterventionCommentBody,
      },
    ],
  },
]);
